<template>
  <main class="main-2025" :class="currentPage">
    <template v-if="currentPage !== null">
      <Transition name="fade" :duration="20" mode="out-in">
        <CheckAge v-if="currentPage === ''" @adult-check="handleAdultCheck" />
        <NewMain key="main" v-else-if="currentPage === 'main'" @update-page="updatePage" @update-guide-visible="updateGuideVisible">
          <template #contents>
            <img :src="mainImage" class="main-image" loading="lazy" alt="메인 이미지" />
            <div class="slide-guide" v-if="guideVisible">
              <div class="wrapper">
                <img src="@/assets/2025/images/01_arrow.png" alt="슬라이드 가이드" />
                <img src="@/assets/2025/images/01_txt.png" alt="슬라이드 가이드" />
              </div>
            </div>
          </template>
        </NewMain>

        <NewMain key="collabo-manseon" v-else-if="currentPage === 'collabo-manseon'" @update-page="updatePage">
          <template #contents>
            <img :src="require('@/assets/2025/images/05_banner.png')" class="banner" alt="짐빔하이볼 로고 since 1795" />
            <img :src="collaboMainImage" class="main-image" alt="메인 이미지" />
            <img :src="require('@/assets/2025/images/05_tit.png')" class="title" alt="지금 이순간 낭만도 있고 짐빔도 있다 - 짐빔 X 만선호프" />
            <div class="event-detail">
              <div>
                <img :src="require('@/assets/2025/images/05_txtbox_txt.png')" class="event-image" alt="원조 만선호프 짐빔점 / 장소: 원조 만선호프(충무로9길 14) / 기간: 25.06.13(금) ~ 25.07.13(일)" />
                <button type="button" class="event-detail-button" alt="자세히 알아보기" @click.prevent.stop="openEventPage">
                  <img :src="require('@/assets/2025/images/05_txtbox_btn.png')" />
                </button>
              </div>
            </div>
          </template>
        </NewMain>

        <NewMain key="new-product" v-else-if="currentPage === 'new-product'" @update-page="updatePage">
          <template #contents>
            <img class="popup-image" :src="newProductImage" />
            <div v-if="promotionVisible" class="promotion-banner">
              <img :src="require('@/assets/2025/images/02_img_event.png')" />
            </div>
            <div class="new-product-button-bar">
              <div class="card">
                <img :src="require('@/assets/2025/images/02_btn_bar.png')" />
              </div>
              <div class="button-bar">
                <button class="buy-product" id="gs25" @click.prevent="handleNewProductPopupButtonClick('gs25')" alt="GS25에서 구매하기">
                  <img :src="promotionVisible ? require('@/assets/2025/images/02_btn_01_event.png') : require('@/assets/2025/images/02_btn_01.png')" />
                </button>
                <button class="buy-product" id="cu" @click.prevent="handleNewProductPopupButtonClick('cu')" alt="CU에서 구매하기">
                  <img :src="promotionVisible ? require('@/assets/2025/images/02_btn_02_event.png') : require('@/assets/2025/images/02_btn_02.png')" />
                </button>
                <button class="buy-product" id="emart24" @click.prevent="handleNewProductPopupButtonClick('emart24')" alt="이마트24에서 구매하기">
                  <img :src="promotionVisible ? require('@/assets/2025/images/02_btn_03_event.png') : require('@/assets/2025/images/02_btn_03.png')" />
                </button>
                <button class="buy-product" id="dailyshot" @click.prevent="handleNewProductPopupButtonClick('dailyshot')" alt="데일리샷에서 구매하기">
                  <img :src="promotionVisible ? require('@/assets/2025/images/02_btn_04_event.png') : require('@/assets/2025/images/02_btn_04.png')" />
                </button>
              </div>
            </div>
          </template>
        </NewMain>

        <NewMain key="game" v-else-if="currentPage === 'game'" @update-page="updatePage">
          <template #contents>
            <img :src="require('@/assets/2025/images/06_bg03.png')" class="main-image" alt="게임 배경 이미지" />
            <img class="game1-image" :src="require('@/assets/2025/images/06_img01.png')" />
            <button id="game1" class="game" @click.prevent.stop="handleGameClick('game1')">
              <img :src="require('@/assets/2025/images/06_btn01.png')" class="main-image" alt="청춘응원편 - 게임하기" />
            </button>
            <template v-if="game2Visible">
              <img class="game2-image" :src="require('@/assets/2025/images/06_img02.png')" />
              <button id="game2" class="game" @click.prevent.stop="handleGameClick('game2')">
                <img :src="require('@/assets/2025/images/06_btn02.png')" class="main-image" alt="고민해결편 - 게임하기" />
              </button>
            </template>
            <template v-else>
              <img class="game2-image off" :src="require('@/assets/2025/images/06_img02_off.png')" />
            </template>
          </template>
        </NewMain>

        <NewMain key="videolist" v-else-if="currentPage === 'videoList'" @update-page="updatePage">
          <template #contents>
            <VideoList />
          </template>
        </NewMain>
        <NotFound v-else @update-page="updatePage" />
      </Transition>
    </template>
  </main>
</template>
<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import CheckAge from './CheckAge.vue'
import NewMain from './NewMain.vue'
import NotFound from './NotFound.vue'
import VideoList from './VideoList.vue'

const openEventPage = () => {
  window.open('https://www.instagram.com/reel/DKyyYC0yC44', '_blank')
}
const currentPage = ref(null)
const mainImage = process.env.BASE_URL + 'img/01_bg_resize.png'
const newProductImage = process.env.BASE_URL + 'img/02_bg_resize.png'
const collaboMainImage = process.env.BASE_URL + 'img/05_bg_resize.png'
const guideVisible = ref(true)

const game1 = {
  url: 'https://simulator-ecru.vercel.app/',
  startDate: '2025-05-23T00:00:00'
}
const game2 = {
  url: 'https://simulator-2.vercel.app/',
  startDate: '2025-06-23T00:00:00'
}

const game2Visible = computed(() => {
  const today = new Date()
  const startDate = new Date(game2.startDate)
  return today >= startDate
})

const promotionVisible = computed(() => {
  const today = new Date()
  const endDate = new Date('2025-06-24T15:00:00')
  return today <= endDate
})

const handleGameClick = game => {
  window.open(game === 'game1' ? game1.url : game2.url, '_blank')
}

function handleAdultCheck(result) {
  if (!result) {
    alert('만 19세 이상 이용 가능합니다.')
    return
  }
  updatePage('main')
}

const updatePage = page => {
  location.hash = page !== '' ? `#${page}` : ''
  window.scrollTo(0, 0)
}
const updateGuideVisible = visible => {
  guideVisible.value = visible
}

const updatePageFromHash = () => {
  const birthInfo = sessionStorage.getItem('birthInfo') || ''
  const savedBirthInfo = birthInfo ? JSON.parse(birthInfo) : null

  if ((savedBirthInfo && savedBirthInfo.age < 19) || (!savedBirthInfo && location.hash === '#main')) {
    alert('만 19세 이상 이용 가능합니다.')
    sessionStorage.removeItem('birthInfo')
    updatePage('')
  } else {
    currentPage.value = null
    setTimeout(() => {
      currentPage.value = location.hash.replace('#', '')
    }, 10)
  }
}

const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
const handleNewProductPopupButtonClick = target => {
  if (isMobile()) {
    switch (target) {
      case 'gs25':
        window.open('https://abr.ge/fvztu2', 'outer')
        break
      case 'cu':
        window.open('https://www.pocketcu.co.kr/deepLink/checkAppInstall?viewType=1&viewUrl=/special/detail/3ROVSZ8Z06935', 'outer')
        break
      case 'emart24':
        window.open('https://urldefense.com/v3/__https://abr.ge/zulffi__;!!HlB2MF95McoOf_k!jFh94zNmwRPdlEz0Ig7wNeAwCrzmAFTO3JE8TfYb9sjYz8EgHn7kJ9cZ8ePumHPeTGMGRzJe-UpJd9X08Sme$', 'outer')
        break
      case 'dailyshot':
        window.open('https://webview.dailyshot.co/event?service_type=0&event_id=645', 'outer')
        break
    }
  } else {
    alert('모바일에서만 사용이 가능합니다.')
  }
}

onMounted(() => {
  window.addEventListener('hashchange', updatePageFromHash)
  updatePageFromHash()
})

onUnmounted(() => {
  window.removeEventListener('hashchange', updatePageFromHash)
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
main.main-2025 {
  background-color: #000000;
  display: flex;
  font-family: 'NanumSquare', sans-serif;
  color: #ffffff;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100svh;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

section .main-image {
  aspect-ratio: 8 / 15;
  user-drag: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
}

section .main-contents .slide-guide {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 6;
}
section .main-contents .slide-guide .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 50%;
  margin: auto;
}
section .main-contents .slide-guide .wrapper img {
  max-width: 100%;
  user-drag: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
}

section .main-contents .banner {
  width: 15%;
  height: auto;
  position: absolute;
  top: 0;
  left: 7%;
  z-index: 1;
}
section .main-contents .title {
  position: absolute;
  top: 10vh;
  z-index: 1;
  right: 5%;
  width: 50%;
  height: auto;
}

section .main-contents .event-detail {
  position: absolute;
  top: 70%;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}
section .main-contents .event-detail > div {
  position: relative;
  text-align: center;
  padding: 2rem;
  margin: 0 auto;
  background-image: url('@/assets/2025/images/05_txtbox.png');
  background-size: cover;
  height: calc(100vw * (559 / 1004));
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 0.5rem;
}
section .main-contents .event-detail > div .event-background-image {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  aspect-ratio: 1004 / 559;
  height: auto;
  object-fit: contain;
}

section .main-contents .event-detail .event-image {
  width: 70%;
  height: auto;
  aspect-ratio: 571 / 187;
  margin: 0 auto;
}

section .main-contents .event-detail .event-detail-button {
  line-height: 0;
  width: 70%;
  height: auto;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-color: transparent;
  -webkit-appearance: none;
  padding: 0;
  overflow: visible;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
}
.promotion-banner {
  position: absolute;
  left: auto;
  right: 0.5%;
  bottom: 7.3%;
  width: 31%;
}
.new-product-button-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  line-height: 0;
  height: auto;
  width: 100%;
}
.new-product-button-bar > .card {
  background: transparent;
  line-height: 0;
}
.new-product-button-bar > .button-bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding: 0.5rem 0.25rem;
  background-color: #fdd000;
  margin-top: -2px;
  /* height: 2.9rem;
  max-height: 7vh; */
}
.new-product-button-bar > .button-bar button {
  background: transparent;
  border: none;
  padding: 0;
  display: inline-flex;
  justify-content: space-evenly;
  align-self: center;
  flex: 1 0 10%;
}
.new-product-button-bar > .button-bar button img {
  width: 75%;
  height: auto;
  object-fit: contain;
  margin: auto;
}
.new-product-button-bar > .button-bar button:first-child {
  flex: 1 0 0;
  min-width: 20%;
  border-right: 1px solid #777152;
}
.new-product-button-bar > .button-bar button:first-child img {
  width: 55%;
}
.new-product-button-bar > .button-bar button:nth-child(2) {
  border-right: 1px solid #777152;
  flex: 1 0 0;
  min-width: 20%;
}

.new-product-button-bar > .button-bar button:nth-child(2) img {
  width: 45%;
}

.new-product-button-bar > .button-bar button:nth-child(3) {
  border-right: 1px solid #777152;
}

.new-product-button-bar > .button-bar button:nth-child(3) img {
  width: 60%;
}

section .main-contents .game1-image {
  position: absolute;
  left: 3.5%;
  width: 44.8%;
  top: 38.2%;
}
section .main-contents .game#game1 {
  position: absolute;
  left: 5.75%;
  top: 75.66%;
  width: 42.5%;
  line-height: 0;
  background: transparent;
}

section .main-contents .game#game1 img {
  aspect-ratio: 145 / 61;
  margin-top: -1px;
}

section .main-contents .game2-image {
  position: absolute;
  right: 1.8%;
  width: 49.7%;
  top: 55.46%;
  margin-top: -1px;
}

section .main-contents .game2-image.off {
  top: 46.26%;
}
section .main-contents .game#game2 {
  position: absolute;
  right: 5.9%;
  top: 46%;
  width: 42.5%;
  line-height: 0;
  background: transparent;
}

section .main-contents .game#game2 img {
  aspect-ratio: 145 / 61;
}
@media (min-width: 640px) {
  section .main-contents .event-detail > div {
    height: calc(var(--desktop-contents-width) * (559 / 1004));
    width: var(--desktop-contents-width);
    padding: 1rem;
    justify-content: center;
    gap: 1rem;
  }
  /* section .main-contents .event-detail .event-image {
    margin: auto;
  }
  section .main-contents .event-detail .event-detail-button {
    margin: auto;
  } */
}
</style>
